<template>
  <div class="mc-status-box" :icon-position="iconPosition">
    <slot name="icon">
      <mu-icon v-if="icon" class="mc-status-box_icon" :icon="icon" />
    </slot>
    <div class="mc-status-box_body">
      <div v-if="titleText" class="mc-status-box_title">
        {{ titleText }}
      </div>
      <div v-if="message" class="mc-status-box_message">
        {{ message }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
  const PresetTitle = {
    stAccessDenied: '无权访问',
    stFatalError: '服务器错误',
    stLoadingFail: '加载失败',
    stNetworkError: '网络故障',
    stNoData: '暂无数据',
    stNoMessage: '暂无消息',
    stNoResult: '查询结果为空',
    stNotFound: '资源无效'
  }

  export default {
    name: 'McStatusBox',
    props: {
      title: String,
      message: String,
      icon: String,
      iconPosition: {
        type: String,
        default: 'top',
        validator (value) {
          return ['top', 'right'].indexOf(value) !== -1
        }
      }
    },
    computed: {
      titleText () {
        return this.title || PresetTitle[this.icon]
      }
    }
  }
</script>

<style>
  .mc-status-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 16px;
    overflow: hidden;

    &[icon-position="right"] {
      flex-direction: row-reverse;
      gap: 32px;

      & > .mc-status-box_body {
        text-align: left;
      }
    }
  }

  .mc-status-box_icon {
    font-size: 120px;
    color: #666;
  }

  .mu-icon.mc-status-box_icon {
    font-size: 120px;
  }

  .mc-status-box_body {
    max-width: 320px;
    overflow: hidden;
    text-align: center;
    flex-shrink: 1;
  }

  .mc-status-box_title {
    overflow: hidden;
    line-height: 20px;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    text-overflow: ellipsis;

    & + * {
      margin-top: 16px;
    }

    & + .mc-status-box_message {
      margin-top: 8px;
    }
  }

  .mc-status-box_message {
    font-size: 12px;
    line-height: 28px;
    color: #434E59;

    & + * {
      margin-top: 16px;
    }
  }
</style>
